<div class="product-order-item--grid-item" *ngIf="product">
        <div class="product-order-item__row">
            <div class="product-order-item--header grid-item" [ngClass]="{ 'item--cut': isItemCut }" >
                <div>
                    <div class="header--row">
                        <div class="image">
                            <app-image-container [image]="imageUrl" type="product" class="clickable"
                                                 [recommended]="isProductRecommended"
                                                 [featured]="showFeaturedTag ? product.isFeatured : false" (click)="onImageClicked()"></app-image-container>
                            <div *ngIf="isItemCut" class="cut-error-banner"><span>{{ 'This item has been cut' | uppercase }}</span></div>
                            <button  *ngIf="!isShopHidden" class="btn btn-primary btn--quick-shop" (click)="shopProduct()" [disabled]="!canBuyProduct">{{shopLabel}}</button>
                        </div>
                        <div class="description">
                            <div class="description__body">
                                <div>
                                    <a routerLink="{{ product.productURL }}" class="link color--primary-grey product--description__label">
                                        <span class="font-4 text-capitalize" [innerHTML]="product.label | safeContent "></span>
                                    </a>
                                    <div style="text-align: left">
                                        <button *ngIf="canSeeFavorites" class="btn btn-icon"
                                                (click)="toggleFavorites()"
                                                [disabled]="updatingFavorites" title="{{hasFavorites ? 'Remove from Favorites' : 'Add to Favorites'}}">
                                            <i *ngIf="updatingFavorites !== true && hasFavorites" class="fas fa-heart color-red"></i>
                                            <i *ngIf="updatingFavorites !== true && !hasFavorites" class="fal fa-heart"></i>
                                            <i *ngIf="updatingFavorites ===  true" class="fal fa-sync rotate"></i>

                                        </button>
                                    </div>
                                </div>

                                <h6 class="product-program color--primary-blue text-align-left" *ngIf="product.getProgram()"
                                    [innerHTML]="product.getProgram() | safeContent "></h6>
                            </div>
                        </div>
                    </div>
                    <!--price-->
                    <div class="header--row subheader">
                        <app-product-order-item-price [orderItem]="orderItem" [product]="product" viewType="grid-item" fontSize="font-4">
                        </app-product-order-item-price>

                        <div class="not-cot" *ngIf="!isItemCut; else showErrorCutText">
                            <app-product-recommened-quantity *ngIf="isProductRecommended" view="grid"
                                [recommendedQty]="product.recommended_qty_expected" [currentQty]="product.recommended_qty_current"
                            ></app-product-recommened-quantity>
                        

                            <!--min order-->
                            <app-product-order-item-min-max class="mt-2" *ngIf="showMinOrder"
                                                            [orderItem]="orderItem"
                                                            [showGroupedMaxQuantity]="true"
                                                            [headerPosition]="true"
                                                            [isRecommended]="isProductRecommended"
                                                            [product]="product" viewType="grid-item" fontSize="font-6">
                            </app-product-order-item-min-max>
                            <app-on-demand-min-max class="mt-2"
                                                            [orderItem]="orderItem"
                                                            [product]="product" viewType="grid-item" fontSize="font-6">
                            </app-on-demand-min-max>

                            <!--in stock-->
                            <app-product-order-item-in-stock
                                    *ngIf="!product.isBuyingWindow"
                                    [showCombinedQuantity] = "product.hasVariations"
                                    [sku]="variationSKU"
                                    [product]="product" [quantity]="orderedQuantity"
                                    fontSize="font-6" viewType="grid-item"></app-product-order-item-in-stock>

                        </div>
                        <ng-template #showErrorCutText>
                            <span class="text-danger font-weight-bold">CUT</span>
                          </ng-template>
                    </div>
                </div>
            </div>
        </div>
</div>



